import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  en: {
    "app.generic.dashboard": "Dashboard",
    "app.genric.menu":"Menu",
    "app.generic.submenu":"Submenu",
    "app.lable.register":"Registration",
    "app.generic.userID":"User ID",
    "app.generic.loginID":"User ID",
    "app.generic.pleaseprovide":"Please provide",
    "app.generic.norecordsfound":"NO RECORDS FOUND",
    "app.login.keeploggedin": "Remember my login information",
    "app.lable.login":"Login",
    "app.login.forgotpassword":"Forgot password",
    "app.login.password": "Password",
    "app.login.newpassword": "New Password",
    "app.login.currentpassword": "Current Password",
    "app.login.confirmpassword": "Confirm Password",
    "app.resetpassword.text":"User ID",
    "app.login.mailid": "Email ID",
    "app.user.name": "Name",
    "app.role.name": "Role Name",
    "app.reset.password": "Reset password",
    "app.generic.here": "Here",
    "app.password.validation1":"The Password must be",
    "app.password.validation2":"digits",
    "app.fuelcapacity.base_angle" : "Base Angle",
    "app.fuelcapacity.fuel_tank_capacity_data_file" : "Fuel Comparison table data file",
    "app.config.time_interval":"Time Interval",
    "app.config.conf_crc":"Config CRC",
    "app.config.conf_sensor_date":"Config Sensor Data",
    "app.config.conf_timestamp":"Config Timestamp",
    "app.config.conf_type":"Config Type",
    "app.config.data_count":"Data Count",
    "app.auth.auth_length":"Auth Length",
    "app.auth.auth_password":"Auth Password",
    "app.auth.auth_user":"Auth User",
    "app.auth.auth_type":"Auth Type",
    "app.auth.auth_user_length":"Auth User Length",
    "DECIM":"",
    "MINLENGTH":"Minimum length is ",
    "RANGENOTE":"",
    "MAXLENGTH":"",
    "SAMEPASSWORD":"",
    "BETWEENRANGE":"",
    "VALIDPASSWORD":"",
    "NUMERIC":"",
    "DECIMAL":"",
    "REQUIREDFIELD":"",
    "KANAERORMSG":""
  },
  ja: {
    "app.generic.dashboard": "ダッシュボード",
    "app.genric.menu":"Menu",
    "app.generic.submenu":"Submenu",
    "app.lable.register":" 新規登録",
    "app.generic.userID":"ユーザーID",
    "app.generic.loginID":"ユーザーID",
    "app.generic.pleaseprovide":"を入力してください",
    "app.register.garden":"登録園.企業",
    "app.generic.norecordsfound":"NORECORDSFOUND",
    "app.login.keeploggedin":"ログイン情報を記憶する",
    "app.lable.login":"ログイン",
    "app.login.forgotpassword":"パスワードをお忘れの場合",
    "app.login.password": "パスワード",
    "app.resetpassword.text":"ユーザーID",
    "app.login.mailid": "Email ID",
    "app.user.name": "Name",
    "app.role.name": "Role Name",
    "app.reset.password": "Reset password",
    "app.password.validation1":"",
    "app.password.validation2":"",
    "DECIM":"",
    "MINLENGTH":"",
    "RANGENOTE":"",
    "MAXLENGTH":"",
    "SAMEPASSWORD":"",
    "BETWEENRANGE":"",
    "VALIDPASSWORD":"",
    "NUMERIC":"",
    "DECIMAL":"",
    "REQUIREDFIELD":"",
    "KANAERORMSG":""
  }
};

const i18n = new VueI18n({ locale: "en", fallbackLocale: "ja", messages });

export default i18n;



// WEBPACK FOOTER //
// ./src/plugins/i18n.js